module.exports = __webpack_public_path__ + "03_short_gray.8259b834.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_short_gray.png
// module id = npF5
// module chunks = 0